import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types' //eslint-disable-line
import { connect } from 'react-redux'
import { Button, Icon, Title } from 'advenio-components'
import { withRouter } from 'react-router'
import VirtualChildrenList from '../../Components/VirtualChildrenList'
import CenterActions from '../../Data/Redux/CenterRedux'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'
import CenterClassroomActions from '../../Data/Redux/CenterClassroomRedux'
import HealthCheckActions from '../../Data/Redux/HealthCheckRedux'
import ModalAssessment from '../../Components/ModalContainer/ModalAssessment'
import InventoryActions from '../../Data/Redux/InventoryRedux'

const Container = styled.div`
  width:100%;
  min-height: 80vh;
  background-color: #F2F2F2;
  padding: 32px 15px 0;
`
const ChildrenContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 650px;
`

const SearchContainer = styled.div`
  margin: 30px auto 0;
  width: 100%;
  max-width: 650px;
  position: relative;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 32px;

  button {
    margin-right: 0;
  }
`
const InputContainer = styled.div`
  position: relative;
  padding: 0 16px;
  background-color: rgba(0,0,0,0.2);
  border-radius: 5px;
  width: 100%;

  input{
    padding: 12px 0px;
    background: transparent;
    transition: color .3s ease-in-out;
    border: 0;
    outline: 0;
    font-size: 16px;
    flex: 1;
    width: 100%;
    margin-top: 4px;
  }

  svg {
    position: absolute;
    right: 8px;
    top: 13px;
  }
`

class VirtualCheckin extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showResetSearch: false,
      name: '',

      childrenToRender: [],
      activeCenter: 0,
      assessment: false,
      child: {},
    }
  }

  componentWillMount() {
    const { user } = this.props

    if (user && user.center_id) {
      this.props.getCenterClassroom(user.center_id)
    }

    this.props.getCenters()
    this.props.getClassrooms({'basic':true,'students':true})
  }

  componentWillUnmount() {
    this.props.clearSearch()
  }

  assessment = (child) => {
    const activeCenter = Number(child.center.id)
    this.props.setActiveCenterId(activeCenter)
    this.setState({ activeCenter })

    this.setState({ assessment: !this.state.assessment, child })
  }

  closeAssessment = () => this.setState({ assessment: false })

  handleChange = e => this.setState({ name: e.target.value })

  handleEnter = (e) => {
    if (e.key === 'Enter') {
      this.searchStudent()
    }
  }

  resetSearch = () => this.setState({ name: '' })

  searchStudent = () => {
    const { name } = this.state

    if (name.length >= 3) {
      this.props.getSearchStudent(name)
    }
  }

  render() {
    const { showResetSearch, name } = this.state
    const { searching, searchResults,studentHomeReport } = this.props

    return (
      <Container>
        <ModalAssessment
          open={this.state.assessment}
          child={this.state.child}
          closeAssessment={this.closeAssessment}
          extra={this.props.healthCheck.Extra}
          revise={this.props.healthCheck.Revise}
          askParent={this.props.healthCheck["Ask Parent"]}
          postChildVirtualHealthCheck={this.props.postChildVirtualHealthCheck}
          healthCheckResponse={this.props.healthCheckResponse}
          centerClassroom={this.props.centerClassroom}
          virtual
          loading={this.props.sendingHealthcheck}
          studentHomeReport={studentHomeReport}
        />

        <Title>Checkin a Centro Virtual</Title>

        <SearchContainer>
          <InputContainer>
            <input type="text" placeholder="Buscar alumno" value={name} onChange={this.handleChange} onKeyPress={this.handleEnter} />
            { showResetSearch && <Icon type="close" color="black" onClick={this.resetSearch} /> }
          </InputContainer>
          <Button
            primary
            disabled={searching}
            loading={searching}
            onClick={this.searchStudent}
          >
            Buscar
          </Button>
        </SearchContainer>

        <ChildrenContainer>
          { !searching &&
            <VirtualChildrenList
              children={searchResults}
              openAssessment={this.assessment}
            />
          }
        </ChildrenContainer>
      </Container>
    )
  }
}

const mapStateToProps = state => ({
  loading: state.centers.get.fetching,
  centers: state.centers.get.results,
  centerClassroom: state.centerClassroom.get.results,
  activeCenterId: state.centers.activeCenterId,
  healthCheck: state.healthCheck.get.results,
  healthCheckResponse: state.healthCheck,
  sendingHealthcheck: state.healthCheck.sending.fetching,
  user: state.auth.user,
  searching: state.inventory.search_student_vCheckin.fetching,
  searchResults: state.inventory.search_student_vCheckin.results,
  studentHomeReport: state.home_report.student_home_report.result,
})

const mapDispatchToProps = dispatch => ({
  getClassrooms: (query) => dispatch(ClassroomActions.getRequest(query,true)),
  getCenters: () => dispatch(CenterActions.getRequest()),
  getCenterClassroom: id => dispatch(CenterClassroomActions.getClassroomRequest(id)),
  setActiveCenterId: id => dispatch(CenterActions.setActiveCenterId(id)),
  postChildVirtualHealthCheck: (id, info) =>
    dispatch(HealthCheckActions.postVirtualHealthCheckRequest(id, info)),
  getSearchStudent: name => dispatch(InventoryActions.getStudentByNameRequest(name)),
  clearSearch: () => dispatch(InventoryActions.clearSearchStudenByName()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VirtualCheckin))



// WEBPACK FOOTER //
// ./src/Containers/VirtualCheckin/VirtualCheckin.jsx